module.exports = __webpack_public_path__ + "static/media/zh_flag.e17abb0c.svg";